import styled from "styled-components";
import {Button} from './index';

// noinspection JSUnresolvedVariable
const CBHeaderTitle = styled.h2`
	background-image: url(${props => props.icon});
`

export const ContentBox = (props) => (<div className={'content-box'} {...props} />);

export const CBHeader = ({icon, title, showEdit, isEdit , editEvent, cancelEditEvent}) => (
	<div className={'box-header'}>
		<CBHeaderTitle icon={icon}>
			{title}
		</CBHeaderTitle>
		{(showEdit && !isEdit) && (<Button className="btn_edit" onClick={editEvent}>Edit</Button>)}
		{(showEdit && isEdit) && (<Button className="btn_edit" onClick={cancelEditEvent}>Cancel</Button>)}
	</div>
);

export const CBBody = (props) => (<div className={'box-content'} {...props} />);

export const CBAction = (props) => (<div className={'form-btn'} {...props} />);

const InternalTextBox =  ({_type, name, value, onChange, disabled, fail}) => (
	<div className={fail ? 'confirm-pw' : null}>
		<label>{name}</label>
		<input type={_type} disabled={disabled} value={value ?? ''} onChange={onChange} />
		{
			fail && (<span>{fail}</span>)
		}
	</div>
);

export const CBTextBox = (props) => <InternalTextBox _type={'text'} {...props} />

export const CBPasswordBox = (props) => <InternalTextBox _type={'password'} {...props} />

